module.exports = __webpack_public_path__ + "img/unlock-wallet.8b2ffc88.png";